import React from "react";
import { MapContainer, TileLayer } from "react-leaflet";

/**
 * Universal map wrapper for Leaflet.
 *
 * Props:
 * - center: [lat, lng]
 * - zoom: number (default 15)
 * - style: CSS style object
 * - closePopupOnClick: boolean (default false)
 * - onBoundsChange: function(bounds) - optional
 * - children: React nodes (Markers, Popups, Layers)
 */
export default function MapComponent({
  center = [51.759, 19.458], // default: Łódź
  zoom = 15,
  style = { height: "60vh", width: "100%" },
  closePopupOnClick = false,
  onBoundsChange,
  children,
}) {

  return (
    <MapContainer
      center={center}
      zoom={zoom}
      style={style}
      closePopupOnClick={closePopupOnClick}
    >
    <TileLayer
        referrerPolicy="strict-origin-when-cross-origin"
        attribution="&copy; OpenStreetMap contributors | DHL eCommerce"
        url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" />
    {children}
    </MapContainer>
  );
}
